// extracted by mini-css-extract-plugin
export default {"card":"styles_card__RYhV6","heading":"styles_heading__qAKal","para":"styles_para__DgiQU","iconWrapper":"styles_iconWrapper__QeiIg"};